export default {
  state: () => ({
    base1: [],
    clientPoints: [],
  }),

  getters: {
    clientPoints: state => {
      return state.clientPoints;
    },
  },

  mutations: {
    setBase1(state, points) {
      state.base1 = points;
    },
    setClientPoints(state, points) {
      state.clientPoints = points;
    },
  },

  actions: {
    async fetchBase1({ commit, rootState }) {
      const statuses = [
        { id: 27, name: 'ativos', color: 'info'},
        { id: 58, name: 'em Aviso', color: 'warning'},
        { id: 43, name: 'bloqueados', color: 'danger'},
      ];

      const { data } = await this.$http.get("/points/count", {
        params: {
          status: statuses.map(s => s.id).join(','),
        },
      });

      if (data.length === 0) {
        return;
      }

      const charts = rootState.tenant.tenant.businesses.map(b => {
        const total = data.reduce((total, result) => total + +(result.cobcart == b.code ? result.count : 0), 0);
        const labels = statuses.map(s => ({
          name: s.name,
          color: s.color,
          total: data.reduce((total, result) => total + +(result.cobcart == b.code && result.situac == s.id ? result.count : 0), 0),
        }));
        return {
          type: b.name,
          total,
          labels,
          chartType: 'Pie',
          chartData: {
            labels: labels.map(l => `${Math.round((l.total / total) * 100)}%`),
            series: labels.map(l => l.total),
          }
        };
      });

      commit('setBase1', charts);
    },
    async createPoint({ commit }, { body }) {
      const { data } = await this.$http.post(`points`, body);
      return data;
    },
    async updatePoint({}, { body }) {
      const { data } = await this.$http.patch(`points`, body);
      return data;
    },
    async fetchPointsByClientId({ commit }, { id }) {
      const { data } = await this.$http.get(`/points/${id}`);
      commit("setClientPoints", data);
    },
    async fetchPointData({ commit }, { pointId, clientId }) {
      const { data } = await this.$http.get(`/points/details`, {
        params: {
          pointId,
          clientId,
        },
      });
      return data;
    }
  },
}
